module.exports = __webpack_public_path__ + "rootfonts/la-solid-900.svg";